import React from "react";
import { motion } from "framer-motion";
import Pano from "./Pano.js"

function Guess(props) {
  const {gameData, round } = props;
  const currItem = gameData[Object.keys(gameData)[round]];
  const isNotSmall = window.matchMedia('screen and (min-width: 30em)').matches;
  props.registerCorrectPosition(currItem);
  const url = currItem["thumbnail"]+"=w800-h800-p"
  let categoryName = currItem.category;
  if(categoryName == 'painting') categoryName = 'visual_arts';
  if(categoryName == 'book') categoryName = 'books';

  let question_text = "";
  if (currItem.question) question_text = props.i18n[currItem.question];
  else if (currItem.category === 'streetview') question_text = props.i18n.where_is_this_located;
  else question_text = props.i18n.where_was_it_made;

  // console.log('categoryName',categoryName)
  // only for streetview
  const GACUrl = 'streetview/'+currItem["id"];

  const imageStyle = {
    backgroundImage: "url(" + url + ")",
  };
  
  // console.log(currItem);

  return (
    <motion.div
      className="w-80-ns w-90 h-100 center flex flex-column justify-start-ns justify-center"
      initial={
        isNotSmall ? { x: '150%', opacity: 0 } : { y: '-150%', opacity: 0 }
      }
      animate={isNotSmall ? { x: '0%', opacity: 1 } : { y: '0%', opacity: 1 }}
      transition={{
        opacity: { duration: isNotSmall? 0.25 : 0  },
        duration:  isNotSmall? 0.45 : 0 ,
        //  delay: 0.5,
        ease: 'easeOut',
      }}
      exit={{ opacity: 0 }}
    >
      <h1 className="normal mt0-ns pt3-ns pt2 pb0-ns pb3 mb3-ns mb0 f2-ns f3-m f4">
        {question_text}
      </h1>
      <div className="flex flex-column-ns flex-row items-center mb0-ns mb3">
        <div className="w-100-ns w-40">
          <div className="aspect-ratio aspect-ratio--1x1 mb4-ns mb2">
            {currItem.category === 'streetview' && isNotSmall ? (
              <Pano thumbnailUrl={url} mapsLoaded={props.mapsLoaded} />
            ) : (
              <img
                className="aspect-ratio--object cover bg-custom-dark br3 fit-cover pointer"
                src={url}
                alt={currItem['title']}
                style={imageStyle}
                onClick={() => {
                  props.displayMoreInfo();
                }}
              />
            )}
          </div>
        </div>
        <div className="w-100-ns w-60 ml0-ns ml3 flex flex-column items-start">
          <p className="pt0 mt0 mb2-ns mb0 ttu f6">
            {props.i18n[categoryName]}
          </p>

          <div className="w-100 relative spoilers db-ns dn">
            <span className="tooltip absolute o-0 f6 bg-custom-dark custom-light pa2 br2 z-2">
              {props.i18n['hidden_text']}
            </span>

            {currItem['title'] !== 'null' ? (
              <h3 className="w-100 pt2 mt0 pb1 mb1 truncate f6 blurred">
                {currItem['title']}
              </h3>
            ) : null}

            {currItem['author'] !== 'null' ? (
              <p className="w-100 pt0 mt0 mb2 truncate f6 blurred">
                {currItem['author']}
              </p>
            ) : null}
            <p className="w-100 pt0 mt0 mb2 truncate f6 blurred">
              {currItem['partner']}
            </p>
          </div>

          {currItem.category === 'streetview' ? (
            <button
              className="mt2 mb3 secondary-btn"
              onClick={() => {
                props.openLink(GACUrl);
              }}
            >
              {props.i18n.view_gac}
            </button>
          ) : (
            <button
              className="mt2 mb3 secondary-btn"
              onClick={() => {
                props.displayMoreInfo();
              }}
            >
              {props.i18n.learn_more}
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
}

export default Guess;
